module.exports = __webpack_public_path__ + "src/img/artist/work05_1.jpg?832c2e60e2ee38b84d537a1d03d2cf6c";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work05_1.jpg
// module id = 22
// module chunks = 0